/* eslint-disable prefer-regex-literals */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/**
 * Applied Jobs page
 */

/**
 * TODO: write applied jobs components and render here.
 */

import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Checkbox,
  Flex,
  Heading,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import NoAppliedJobsIcon from "assets/NoJobs.svg";
import NumberSort from "assets/number.svg";
import SortAZIcon from "assets/sort-az-Icon.svg";
import { SecondaryButton } from "components/base/atoms/HJSButton";
import NoData from "components/NoData";
import { useGetApliedJobQuery } from "queries/Jobs";
import { useGetCompanyNameListQuery } from "queries/Jobs/AppliedJobs";
import { lazy, useEffect, useReducer, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import TableRow from "./TableRow";

const columns = [
  "Company",
  "Job Title",
  "Status",
  "Hours per week",
  "Hourly Pay",
];

let sortedColumn: string;

/**
 * @description Applied job page and its menu, interfaces and reducers etc.
 *
 */

const headerStatus = [
  // "Saved - Not applied to",
  "Applied - Have not heard back",
  "Applied - Scheduled interview",
  "Applied - Received offer!",
  "Applied - Rejected",
  // "Might apply later",
];

interface IHeaderMenu {
  company: any;
  jobTitle: any;
  status: any;
  "job title": any;
}

const initialSelection: IHeaderMenu = {
  company: {},
  jobTitle: {},
  status: {},
  "job title": {},
};

const reducer = (state: IHeaderMenu, action: any): IHeaderMenu => {
  const { payload } = action;

  const prop = "job title";
  switch (action.type) {
    case "COMPANY":
      if (state.company[payload.idx] as boolean)
        delete state.company[payload.idx];
      else state.company[payload.idx] = true;
      break;
    case "JOB_TITLE":
      if (state[prop][payload.idx] as boolean) delete state[prop][payload.idx];
      else state[prop][payload.idx] = true;
      break;
    case "STATUS":
      if (state.status[payload.idx] as boolean)
        delete state.status[payload.idx];
      else state.status[payload.idx] = true;
      break;
    default:
      break;
  }

  return { ...state };
};

const AppliedJobs = (): JSX.Element => {
  const [appliedJobs, setAppliedJobs] = useState<any[]>([]);
  const [headerMenuState, dispatch] = useReducer(
    reducer,
    initialSelection
  ) as any;

  const [prevPayload, setPrevPaylaod] = useState({}) as any;
  const defaultPayload = { page: 1, perPage: 10 };
  const [payload, setPayload] = useState(defaultPayload) as any;

  const { data: getAppliedJobs } = useGetApliedJobQuery(payload);
  const { data: getCompaniesList } = useGetCompanyNameListQuery() as any;

  useEffect(() => {
    return () => console.log("unmounting");
  }, []);
  const handleMenuChange = (
    e: any,
    { idx, column }: { idx: number; column: string }
  ): void => {
    const payload = { idx };
    switch (column) {
      case "Company":
        dispatch({ type: "COMPANY", payload });
        break;
      case "Job Title":
        dispatch({ type: "JOB_TITLE", payload });
        break;
      case "Status":
        dispatch({ type: "STATUS", payload });
        break;
      default:
        break;
    }
  };

  // handle sorting w.r.t. columns
  const handleSort = (column: string): void => {
    const hoursPerWeekcomparator = (a: any, b: any): any => {
      return a.hoursPerWeek?.localeCompare(b.hoursPerWeek);
    };

    if (sortedColumn === column) {
      // if (sortedColumn === columns[2])
      //   setAppliedJobs((prev: any) => [
      //     ...prev.sort((a: any, b: any) => a.status?.localeCompare(b.status)),
      //   ]);
      // else
      setAppliedJobs((prev: any[]) => [...prev.reverse()]);
      sortedColumn = "";
    } else {
      switch (column) {
        case columns[0]:
          setAppliedJobs((prev: any) => {
            const arr = [
              ...prev.sort((a: any, b: any) =>
                a.job?.CompanyName?.localeCompare(b.job?.CompanyName)
              ),
            ];
            return arr;
          });
          break;
        case columns[1]:
          setAppliedJobs((prev: any) => [
            ...prev.sort((a: any, b: any) =>
              a.job?.title?.localeCompare(b.job?.title)
            ),
          ]);
          break;
        case columns[2]:
          setAppliedJobs((prev: any) => [
            ...prev.sort((a: any, b: any) => a.status?.localeCompare(b.status)),
          ]);
          break;
        case columns[3]:
          setAppliedJobs((prev: any) => {
            return [...prev.sort(hoursPerWeekcomparator)];
          });
          break;
        case columns[4]:
          setAppliedJobs((prev: any) => {
            return [
              ...prev.sort((a: any, b: any) =>
                a.hourlyPay?.localeCompare(b.hourlyPay)
              ),
            ];
          });
          break;
        default:
          break;
      }
      sortedColumn = column;
    }
  };

  const fetchMoreJobs = (): void => {
    setPayload((prev: any) => {
      setPrevPaylaod(prev);
      return { ...prev, page: (prev.page as number) + 1 };
    });
  };

  useEffect(() => {
    setAppliedJobs([]);
  }, [
    payload?.company?.length,
    payload?.title?.length,
    payload?.status?.length,
  ]);

  // append data when get new data for the next page
  useEffect(() => {
    let shouldAppend = false;
    for (const props in payload) {
      if (prevPayload[props] !== payload[props]) {
        shouldAppend = true;
        break;
      }
    }
    if (getAppliedJobs?.data?.length > 0 && !shouldAppend)
      setAppliedJobs(getAppliedJobs?.data);
    if (getAppliedJobs?.data?.length > 0 && shouldAppend) {
      const appliedJobsList = getAppliedJobs?.data;
      setAppliedJobs((prev) => [...prev, ...appliedJobsList]);
      setPrevPaylaod(payload);
    }
  }, [getAppliedJobs?.data]);

  // get selected title and companies name from the list
  // whenever user select something from header menu
  useEffect(() => {
    if (getCompaniesList?.data?.length > 0) {
      const company = Object.keys(headerMenuState.company).map((el: any) => {
        return getCompaniesList?.data?.[Number(el)]?.company;
      });
      const title = Object.keys(headerMenuState["job title"]).map((ind) => {
        return getCompaniesList?.data?.[Number(ind)]?.title;
      });
      const status = Object.keys(headerMenuState.status).map((ind) => {
        return headerStatus[Number(ind)];
      });

      setPayload(() => {
        return { page: 1, perPage: 10, company, title, status };
      });
    }
  }, [headerMenuState]);

  return (
    <>
      <Box
        px={{
          base: 6,
          md: 14,
          lg: 20,
          "2xl": 32,
          "3xl1": "initial",
        }}
        maxW="1600px"
        mx="auto"
        // mt={10}
        // minH="70vh"
      >
        <Heading
          as="h1"
          fontWeight="700"
          fontSize="1.8rem"
          color="teal.900"
          mb={6}
        >
          Applied Jobs
        </Heading>
        <TableContainer
          maxH="33rem"
          overflow="auto"
          id="appliedJobScrollable"
          minH={80} // for table menu
        >
          <InfiniteScroll
            dataLength={appliedJobs.length >= 0 ? appliedJobs.length : 1}
            next={fetchMoreJobs}
            hasMore={appliedJobs?.length >= 10}
            loader={<> </>}
            scrollableTarget="appliedJobScrollable"
            height="fit-content"
            className="max-h-[33rem] min-h-[20rem] overflow-auto"
          >
            <Table size="sm">
              <Thead
                background="teal.600"
                position="sticky"
                top="0rem"
                left="0rem"
                zIndex={1}
              >
                <Tr>
                  {columns.map((column, idx) => (
                    <Th
                      key={idx}
                      py={4}
                      width={
                        idx === 3 ? "200px" : idx === 4 ? "170px" : "initial"
                      }
                      minW={
                        idx === 3 ? "200px" : idx === 4 ? "170px" : "initial"
                      }
                    >
                      <Flex alignItems="center" gap={2}>
                        {/* {idx !== columns.length - 1 && ( */}
                        <Tooltip
                          label={`Arrange it ${
                            idx > 2 ? "alphanumerically" : "alphabetically"
                          }`}
                          placement="top"
                        >
                          <Image
                            src={idx > 2 ? NumberSort : SortAZIcon}
                            alt="sort icon"
                            onClick={() => handleSort(column)}
                            cursor="pointer"
                          />
                        </Tooltip>
                        {/* // )} */}
                        {idx < 3 ? (
                          <Menu closeOnSelect={false}>
                            {({ isOpen, onClose }) => (
                              <>
                                <MenuButton
                                  as={SecondaryButton}
                                  rightIcon={
                                    <ChevronDownIcon className="fill-white ml-10" />
                                  }
                                >
                                  <Text color="white" fontSize={18}>
                                    {column}
                                  </Text>
                                </MenuButton>
                                <MenuList
                                  backgroundColor="teal.600"
                                  color="white"
                                  py={4}
                                  border="none"
                                  maxH={52}
                                  overflowY="auto"
                                >
                                  {column !== "Status"
                                    ? getCompaniesList?.data?.map(
                                        (options: any, ind: number) => (
                                          <Tooltip
                                            label={
                                              column === "Comapny"
                                                ? options?.Comapny
                                                : options?.title
                                            }
                                            hasArrow
                                            placement="bottom-end"
                                            key={ind}
                                          >
                                            <MenuItem
                                              backgroundColor="teal.600"
                                              fontSize="md"
                                              fontWeight="semibold"
                                              _hover={{
                                                backgroundColor:
                                                  "hjsSecondaryHover",
                                              }}
                                              _focus={{
                                                backgroundColor:
                                                  "hjsSecondaryHover",
                                              }}
                                            >
                                              <Checkbox
                                                className="ai-checkbox"
                                                colorScheme="white"
                                                isChecked={
                                                  headerMenuState[
                                                    column.toLowerCase()
                                                  ]?.[ind] ?? false
                                                }
                                                onChange={(e: any) => {
                                                  handleMenuChange(e, {
                                                    idx: ind,
                                                    column,
                                                  });
                                                  onClose();
                                                }}
                                              >
                                                <Text
                                                  fontSize="1rem"
                                                  fontWeight="600"
                                                  color="white"
                                                >
                                                  {column === "Company"
                                                    ? options?.company?.length >
                                                      12
                                                      ? options?.company
                                                          ?.substr(0, 10)
                                                          .concat("...")
                                                      : options?.company
                                                    : column === "Job Title" &&
                                                      (options?.title?.length >
                                                      12
                                                        ? options?.title
                                                            ?.substr(0, 10)
                                                            .concat("...")
                                                        : options?.title)}
                                                </Text>
                                              </Checkbox>
                                            </MenuItem>
                                          </Tooltip>
                                        )
                                      )
                                    : headerStatus?.map((el, index) => (
                                        <MenuItem
                                          key={index}
                                          backgroundColor="teal.600"
                                          fontSize="md"
                                          fontWeight="semibold"
                                          _hover={{
                                            backgroundColor:
                                              "hjsSecondaryHover",
                                          }}
                                          _focus={{
                                            backgroundColor:
                                              "hjsSecondaryHover",
                                          }}
                                        >
                                          <Checkbox
                                            className="ai-checkbox"
                                            colorScheme="white"
                                            isChecked={
                                              headerMenuState[
                                                column.toLowerCase()
                                              ]?.[index] ?? false
                                            }
                                            onChange={(e: any) => {
                                              handleMenuChange(e, {
                                                idx: index,
                                                column,
                                              });
                                            }}
                                          >
                                            <Text
                                              fontSize="1rem"
                                              fontWeight="600"
                                              color="white"
                                            >
                                              {el}
                                            </Text>
                                          </Checkbox>
                                        </MenuItem>
                                      ))}
                                </MenuList>
                              </>
                            )}
                          </Menu>
                        ) : (
                          <Text
                            color="white"
                            fontSize={18}
                            textTransform="none"
                          >
                            {column}
                          </Text>
                        )}
                      </Flex>
                    </Th>
                  ))}
                </Tr>
              </Thead>

              <Tbody>
                {appliedJobs?.length > 0 ? (
                  appliedJobs?.map((job: any, idx: number) => (
                    <TableRow
                      job={job}
                      key={idx}
                      jobIdx={idx}
                      setAppliedJobs={setAppliedJobs}
                    />
                  ))
                ) : (
                  <Tr>
                    <Td colSpan={5} py={28}>
                      <NoData
                        src={NoAppliedJobsIcon}
                        bodyMessage="You haven’t applied to any jobs yet!"
                        footerMessage={
                          <>
                            Click on&nbsp;
                            <Link href="/jobs/search" className="!underline">
                              Job Search
                            </Link>{" "}
                            to find jobs.
                          </>
                        }
                      />
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </InfiniteScroll>
        </TableContainer>
      </Box>
    </>
  );
};

export default AppliedJobs;
